// src/contexts/LoaderContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { Box, Flex, keyframes, Image } from '@chakra-ui/react';
import { loaderService } from '../services/loaderService';
import logo from '../assets/img/layout/logo_uccellini_u.png';

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

// Animación de giro
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onChange = (value) => setLoading(value);
    loaderService.on('change', onChange);
    return () => {
      loaderService.off('change', onChange);
    };
  }, []);

  return (
    <LoaderContext.Provider value={{ loading }}>
      {children}
      {loading && (
        <Flex
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bg="rgba(255, 255, 255, 0.72)"
          align="center"
          justify="center"
          zIndex={document.querySelector('[data-sync-modal]') ? -1 : 1000}
          pointerEvents="auto"
          style={{ display: document.querySelector('[data-sync-modal]') ? 'none' : 'flex' }}
        >
          <Box position="relative" width="88px" height="88px">
            <Box
              position="absolute"
              inset={0}
              borderRadius="50%"
              border="4px solid rgba(0, 48, 100, 0.25)"
              borderTopColor="rgba(0, 48, 100, 0.85)"
              animation={`${spin} 1s linear infinite`}
            />
            <Flex
              position="absolute"
              inset={0}
              align="center"
              justify="center"
            >
              <Image
                src={logo}
                alt="Logo"
                maxW="52px"
                maxH="52px"
                objectFit="contain"
              />
            </Flex>
          </Box>
        </Flex>
      )}
    </LoaderContext.Provider>
  );
};
